export const languageOptions = [

  {
    id: 71,
    name: "Botlang (0.0.1)",
    label: "Botlang (0.0.1)",
    value: "python",
  }
];
